
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0m1,17H7a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2m4-4H7a1,1,0,0,1,0-2H17a1,1,0,0,1,0,2m0-4H7A1,1,0,0,1,7,7H17a1,1,0,0,1,0,2"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  